<template>
  <label for="branch-select-component" class="form-label">
    {{ $t('branch.name') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedBranch"
    :options="{
      create: false,
      placeholder: $t('branch.select')
    }"
    class="w-full"
  >
    <option v-for="branch in branches" :value="branch.uuid" :key="branch.uuid">
      {{ branch.title }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import branchApi from '../../services/branches/branch.api'

export default defineComponent({
  data() {
    return {
      branches: []
    }
  },
  mounted() {
    if (this.employeeUUID !== null) {
      branchApi.employeeGetList(1, 100).then(
        response => {
          this.branches = response.data.data
          if (response.data.data.length > 0) {
            this.$emit('update:selectedBranch', {
              selectedBranch: response.data.data[0].uuid
            })
          }
        },
        error => {
          console.log(error)
        }
      )
      return
    }
    branchApi.getList(1, 100).then(
      response => {
        this.branches = response.data.data
        if (response.data.data.length > 0) {
          this.$emit('update:selectedBranch', {
            selectedBranch: response.data.data[0].uuid
          })
        }
      },
      error => {
        console.log(error)
      }
    )
  },

  props: {
    selectedBranch: {
      type: Object,
      default: () => {}
    },
    employeeUUID: {
      type: String,
      default: () => null
    }
  },

  emits: ['update:selectedBranch'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedBranch,
      set: value => emit('update:selectedBranch', value)
    })

    return {
      componentValue
    }
  }
})
</script>
